import { isDefined } from "@perxis-auto/shared";
const formatVehicleTags = (tags) => tags.reduce((acc, tag) => {
  if (isDefined(tag.displayName)) {
    acc.push({
      key: tag.id,
      label: tag.displayName,
      description: tag.description || tag.displayName,
      color: tag.fontColor,
      borderColor: tag.borderColor,
      backgroundColor: tag.backgroundColor
    });
  }
  return acc;
}, []);
export {
  formatVehicleTags
};
